import { render, staticRenderFns } from "./CarterMetricsClinical.vue?vue&type=template&id=81a8edaa&"
import script from "./CarterMetricsClinical.vue?vue&type=script&lang=ts&"
export * from "./CarterMetricsClinical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports